import api from '@/services/Api'

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    page: 1,
    data: [],
    single: null,
    category: 'start', // default category
    news: [],
    last_page: 1
};

// ----------------------------- o

const getters = {

};

// ----------------------------- o

const actions = {
    'KNOWLEDGE_ACADEMIES_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_ACADEMIES_REQUEST');
            let url = 'knowledges/academies';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('KNOWLEDGE_ACADEMIES_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_ACADEMIES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'KNOWLEDGE_ACADEMIES_SINGLE_REQUEST': ({commit, dispatch}, academy_slug) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_ACADEMIES_REQUEST');
            dispatch('KNOWLEDGE_ACADEMIES_NEWS_SET_PAGE', true);
            let url = 'knowledges/academies/'+academy_slug;
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('KNOWLEDGE_ACADEMIES_SET_SINGLE', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_ACADEMIES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'KNOWLEDGE_ACADEMIES_NEWS_REQUEST': ({commit, dispatch}, academy_slug) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_ACADEMIES_REQUEST');
            if(state.last_page >= state.page){
                let url = 'knowledges/academies/'+academy_slug+'/news?page='+state.page;
                api({url: url, method: 'GET'})
                    .then(resp => {
                        commit('KNOWLEDGE_ACADEMIES_NEWS_SUCCESS', resp.data);
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('KNOWLEDGE_ACADEMIES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                        reject(err)
                    })
            }
        })
    },
    'KNOWLEDGE_ACADEMIES_NEWS_SET_PAGE': ({commit, dispatch}, reset) => {
        commit('KNOWLEDGE_ACADEMIES_NEWS_SET_PAGE', reset);
    },
    'KNOWLEDGE_ACADEMIES_SET_CATEGORY': ({commit, dispatch}, category) => {
        commit('KNOWLEDGE_ACADEMIES_SET_CATEGORY', category);
    },
    'KNOWLEDGE_ACADEMIES_JOIN': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_ACADEMIES_REQUEST');
            let url = 'knowledges/academies/'+payload.academy_slug+'/join';
            api({url: url, data: payload.data, method: 'POST'})
                .then(resp => {
                    dispatch('GLOBAL_TOAST','Otrzymaliśmy Twoje zgłoszenie.', {root:true});
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_ACADEMIES_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
}

// ----------------------------- o

const mutations = {
    'KNOWLEDGE_ACADEMIES_REQUEST': (state) => {
        state.errors = {};
        state.loading = true;
    },
    'KNOWLEDGE_ACADEMIES_SUCCESS': (state, resp) => {
        state.data = resp;
        state.loading = false;
    },
    'KNOWLEDGE_ACADEMIES_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false;
    },
    'KNOWLEDGE_ACADEMIES_SET_SINGLE': (state, data) => {
        state.single = data;
        // TEMP: fix academy bookmarks with missing start-tabs
        let missingTabs = [
            {
                name: 'Start',
                slug: 'start'
            },
            {
                name: 'Aktualności',
                slug: 'news'
            },
        ]
        state.single.bookmarks = [...missingTabs, ...state.single.bookmarks]
        state.loading = false;
    },
    'KNOWLEDGE_ACADEMIES_NEWS_SUCCESS': (state, resp) => {
        state.news = state.page > 1 ? state.news.concat(resp.data) : resp.data;
        state.last_page = resp.last_page;
        state.loading = false;
    },
    'KNOWLEDGE_ACADEMIES_NEWS_SET_PAGE': (state, reset) => {
        state.page = reset ? state.page = 1 : state.page + 1;
    },
    'KNOWLEDGE_ACADEMIES_SET_CATEGORY': (state, category) => {
        state.category = category;
    }
}

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}